// Chart color palette for analytics. Easy to update — just change the hex values.
// Order matters: first project in sorted results gets palette[0], etc.

export const PROJECT_COLORS = [
  '#234f7a', // steel blue (primary)
  '#2d9d6a', // teal green
  '#7c4dbd', // purple
  '#3a8cc2', // medium blue
  '#d5632d', // orange (context accent)
  '#c7a032', // gold
  '#d94f7a', // rose
  '#5d8c3e', // olive green
  '#8b6cc1', // lavender
  '#c26a3a', // burnt sienna
]

export const NO_PROJECT_COLOR = '#c4cad1'
export const UNTAGGED_COLOR = '#c4cad1'
export const CONTEXT_COLOR = 'rgba(213, 99, 45, 0.18)'
export const CONTEXT_BORDER_COLOR = 'rgba(213, 99, 45, 0.5)'
export const CONTEXT_ACCENT_COLOR = '#d5632d'
export const OTHER_COLOR = '#a0a8b0'

export function colorForIndex(i) {
  return i < PROJECT_COLORS.length ? PROJECT_COLORS[i] : OTHER_COLOR
}

export function assignColors(items) {
  return items.map((item, i) => ({
    ...item,
    color: item.name === 'No project' || item.name === 'Untagged'
      ? NO_PROJECT_COLOR
      : colorForIndex(i),
  }))
}

// Build a stable { name → color } map from a sorted list.
// Use the same sort order as the backend (descending seconds) as the canonical source.
export function buildNameColorMap(items) {
  const map = {}
  let idx = 0
  ;(items || []).forEach(item => {
    const name = item.name
    if (!name) return
    map[name] = (name === 'No project' || name === 'Untagged')
      ? NO_PROJECT_COLOR
      : colorForIndex(idx++)
  })
  return map
}
